import { useState } from 'react'
import { FormattedMessage } from 'react-intl'
import CancellationTermsModal from './CancellationTermsModal'

export default function CancellationPolicy({
  currency,
  isCustomCancellation,
  customCancellationText,
  milestones,
  freeCancellationDays,
}) {
  const [isOpen, setIsOpen] = useState(false)
  const openModal = () => setIsOpen(true)
  const closeModal = () => setIsOpen(false)
  return (
    <div className='payment-terms'>
      <a className='payment-terms-btn ng-binding' onClick={openModal}>
        <FormattedMessage
          id='cancellationPolicy'
          defaultMessage='Cancellation policy'
        />
      </a>
      <CancellationTermsModal
        currency={currency}
        isCustomCancellation={isCustomCancellation}
        customCancellationText={customCancellationText}
        onClose={closeModal}
        isOpen={isOpen}
        milestones={milestones}
        freeCancellationDays={freeCancellationDays}
      />
    </div>
  )
}
